module.exports = __webpack_public_path__ + "media/images/views/home/home-register-6b05d8454a6713cbe6fc27c159f92ded.png";